import { render, staticRenderFns } from "./block-rental-vehicle.vue?vue&type=template&id=4b8c07e3&scoped=true&"
import script from "./block-rental-vehicle.vue?vue&type=script&lang=js&"
export * from "./block-rental-vehicle.vue?vue&type=script&lang=js&"
import style0 from "./block-rental-vehicle.vue?vue&type=style&index=0&id=4b8c07e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c07e3",
  null
  
)

export default component.exports